import React from 'react'
import { EntryPage } from '@emerald-works-nova/auth'
import { Grid, Link } from '@mui/material'
import { MailSent } from '../../../components/entry-decoration'
import { useStyles } from '../style'

const ForgotPasswordEndPage = () => {
  const classes = useStyles()

  return (
    <Grid
      container
      direction='column'
      wrap='nowrap'
    >
      <Grid item style={{ minHeight: 85 }} />
      <Grid item>
        <EntryPage
          title='Check your email address'
          showMtLogo
          subtitle="If there's an account linked to this email address, we'll send over instructions to reset your password."
          application={process.env.REACT_APP_APPLICATION_NAME}
          content={<Link href='/login' className={classes.bottomLink} underline='hover'> Back to Sign In</Link>}
          decoration={<MailSent />}
        />
      </Grid>

    </Grid>
  )
}

export default ForgotPasswordEndPage
